import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import useAnalyticsContext from 'src/analytics/useAnalyticsContext'
import {
  selectDeletingUserFromState,
  selectTopLevelErrorFromState,
} from 'src/app/ProfileDelete/redux/profileDelete.selectors'
import BackgroundPageContent from 'src/components/BackgroundPageContent/BackgroundPageContent'
import DeleteProfileBox from 'src/components/DeleteProfileBox/DeleteProfileBox'
import { useBackgroundDispatch } from 'src/hooks'
import { deleteUser } from 'src/redux/actions/data/users.actions'
import { selectAppName } from 'src/redux/selectors/session.selectors'

const ProfileDelete: React.FC = () => {
  const deletingUser = useSelector(selectDeletingUserFromState)
  const topLevelError = useSelector(selectTopLevelErrorFromState)
  const appName = useSelector(selectAppName)
  const { analytics } = useAnalyticsContext()

  const dispatch = useBackgroundDispatch()
  const dispatchDeleteUserThenSignout = (): void => {
    dispatch(deleteUser(analytics))
  }

  return (
    <>
      <Helmet>
        <title>{`Delete Profile | ${appName}`}</title>
        <meta
          name="description"
          content={`Delete Profile page of ${appName}`}
        />
      </Helmet>
      <BackgroundPageContent>
        <DeleteProfileBox
          deleteProfile={dispatchDeleteUserThenSignout}
          deletingUser={deletingUser}
          topLevelError={topLevelError}
        />
      </BackgroundPageContent>
    </>
  )
}

export default ProfileDelete
